import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-22/task-01";

const task: Slide = {
  title: "Please order the following six items according to the scientific procedure to check a hypothesis.",
  description: "Drag and drop elements.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
